import searchIcon from './../../images/search-icon.svg';
import searchEmoji from './../../images/search.png';
import filterIcon from './../../images/filter.svg';
import './Search.css';
const Search = ({ setCurrentPage, eventSubCategory, isFullScreenMode }) => {
    const handleCategoriesClick = () => {
        setCurrentPage('TypeEventsPage');
    };

    return (
        <div
            className={
                isFullScreenMode
                    ? 'search__container_full'
                    : 'search__container'
            }
        >
            <div className='search__items'>
                <img className='search__icons' src={searchIcon} />
                <input type='text' value={eventSubCategory} disabled />
                <img className='search__icon_add' src={searchEmoji} />
            </div>
            <div className='filter__items' onClick={handleCategoriesClick}>
                <img src={filterIcon} />
            </div>
        </div>
    );
};

export default Search;
